import logo from './logo.svg';
import './App.scss';
import React, { Component } from 'react'
import Main from './page/main/Main';
import Login from './page/login/Login';
import Xloading from './page/xloading/Xloading';
import ConverterMain from './page/tool/ConverterMain';
import ImgConvert from './page/tool/ImgConvert';
import DataConvert from './page/dataConv/DataConvert';
import UploadPanel from './page/upload/UploadPanel';
// import ContextMenu from './components/ContextMenu';
// import DragDrop from './components/DragDrop';
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from 'react-router-dom';
import 'antd/dist/reset.css';
// import { observer,inject } from 'mobx-react';
import WorldMap from './page/world/WorldMap';

// import FileSaver from 'file-saver';
import { Workbook } from "exceljs";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: true
    }
  }
  componentDidMount() {
    // this.onDownload()
  }
  getMapUI = () => {
    return;
  }
  onLogin = (status) => {
    if (status) {
      this.setState({
        isLoggedIn: status
      })
    }
  }
  onLogout = () => {
    return <Redirect to="/" />;
  }
  onDownload = async () => {
    const workbook = new Workbook();
    const sheet = workbook.addWorksheet('Sheet1');

    const rowSubHead = sheet.addRow(['A', 'B', 'C']);

    rowSubHead.eachCell((sCell) => {
      sCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF90EE90' } // 浅绿色
      };
      sCell.font = { bold: true, color: { argb: 'FF90EE90' } };
    });


    const rowSubHead1 = sheet.addRow(['A', 'B', 'C']);

    rowSubHead1.eachCell((sCell) => {
      // sCell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'FF90EE90' } // 浅绿色
      // };
      sCell.font = { bold: true, color: { argb: 'FFFF0000' } };
    });

    const cellsStyle = {
      font: { color: { argb: 'FFFF0000' }, size: 14, bold: true },
      fill: { fgColor: { argb: 'FFFFFFFF' }, pattern: 'solid' },
      alignment: { vertical: 'middle', horizontal: 'center', wrapText: false, shrinkToFit: false },
    }

    const rowSubHead2 = sheet.addRow(['A', 'B', 'C']);

    rowSubHead2.eachCell((sCell) => {
      sCell.font = cellsStyle.font
      sCell.fill = cellsStyle.fill
      sCell.alignment = cellsStyle.alignment
    });



    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'test.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }
  render() {
    let { isLoggedIn } = this.state;
    const ThemeContext = React.createContext("light");
    return (
      <ThemeContext.Provider value="dark">
        <Router>
          <Route exact path="/map">
            {isLoggedIn ? <Main /> : <Login onLogin={this.onLogin} />}
          </Route>
          <Route exact path="/map/world">
            <WorldMap />
          </Route>
          <Route exact path="/map/wktToGeoJson">
            <ConverterMain />
          </Route>
          <Route exact path="/map/imgConvert">
            <ImgConvert />
          </Route>
          <Route exact path="/map/dataConvert">
            <DataConvert />
          </Route>
          <Route exact path="/map/upload">
            <UploadPanel />
          </Route>
        </Router>
      </ThemeContext.Provider>
    )
  }
}